import ExternalLinkIcon from 'assets/images/icons/external-link.svg?react';
import { DocumentLink } from '../../LeadModalStayDetailsTab.styles';

const GovernmentFieldValue = ({
  passportID,
  passportCountryCode,
  identificationDocumentUrl,
}: {
  passportID?: string;
  passportCountryCode?: string;
  identificationDocumentUrl?: string;
}) => {
  return (
    <>
      {passportCountryCode ? `${passportCountryCode}, ` : ''}
      {passportID || ''}
      {identificationDocumentUrl ? (
        <DocumentLink
          href={identificationDocumentUrl}
          target="_blank"
          rel="noreferrer"
        >
          <ExternalLinkIcon />
        </DocumentLink>
      ) : (
        ''
      )}
    </>
  );
};

GovernmentFieldValue.defaultProps = {
  passportID: '',
  passportCountryCode: '',
  identificationDocumentUrl: '',
};

export default GovernmentFieldValue;
